import { render, staticRenderFns } from "./RemoveSpecimensSpareToInventory.vue?vue&type=template&id=1fd00b66&scoped=true"
import script from "./RemoveSpecimensSpareToInventory.vue?vue&type=script&lang=js"
export * from "./RemoveSpecimensSpareToInventory.vue?vue&type=script&lang=js"
import style0 from "./RemoveSpecimensSpareToInventory.vue?vue&type=style&index=0&id=1fd00b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd00b66",
  null
  
)

export default component.exports